/* eslint-disable @typescript-eslint/no-use-before-define */
import { Typography } from '@euler/app/components/typography';
import { AppNavParams } from '@euler/app/Routes';
import { Colors } from '@euler/components/Colors';
import { Icon } from '@euler/components/Icomoon';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { useOnNavigateBack } from '@euler/functions/useOnNavigateBack';
import { useSystemMetrics } from '@euler/functions/useSystemMetrics';
import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { LinearGradient } from 'expo-linear-gradient';
import React, { memo, ReactNode } from 'react';
import {
  StyleProp,
  StyleSheet,
  TextStyle,
  TouchableOpacity,
  View,
} from 'react-native';
import {} from 'react-native-redash';
import { TaskHeaderMoreButton } from './HeaderOptions';
import { TaskNavBarSpinner } from './NavBarSpinner';

export const TabletTaskNavBar = memo(
  ({
    title,
    showVehicleInfo = true,
    vehicleName,
    licensePlateNo,
    titleLoadingIndicator,
    accessoryText,
    colors = ['#006be4', '#5ba0e0'],
    titleStyle,
    rightOptions,
    onShowActions,
  }: {
    title: string;
    vehicleName: string;
    licensePlateNo: string;
    titleLoadingIndicator?: boolean;
    showVehicleInfo?: boolean;
    accessoryText?: string;
    colors?: string[];
    titleStyle?: StyleProp<TextStyle>;
    rightOptions?: () => ReactNode;
    onShowActions?: () => void;
  }) => {
    const navigation = useNavigation<StackNavigationProp<AppNavParams>>();
    const { rpx } = useResponsiveContext();
    const { navBarHeight, safeAreaInsets } = useSystemMetrics();

    const onBackPress = useOnNavigateBack(() => {
      if (navigation.canGoBack()) {
        navigation.goBack();
      } else {
        navigation.replace('Main', {});
      }
    });

    return (
      <>
        <View
          css={`
            height: ${navBarHeight}px;
            padding-top: ${safeAreaInsets.top}px;
            justify-content: space-between;
            align-items: center;
            flex-direction: row;
            padding-left: ${rpx(15)}px;
            padding-right: ${rpx(16)}px;
          `}
        >
          <View style={[StyleSheet.absoluteFill]}>
            <LinearGradient
              start={{ x: 0, y: 0.5 }}
              end={{ x: 1, y: 1 }}
              colors={colors}
              locations={[0.335, 1]}
              style={StyleSheet.absoluteFill}
            />
          </View>
          <View
            css={`
              padding-top: ${safeAreaInsets.top}px;
              justify-content: center;
              align-items: center;
              flex-direction: row;
            `}
            style={[StyleSheet.absoluteFill]}
          >
            <TaskNavBarSpinner animating={false} offsetX={rpx(-3)} />
            <Typography.Label
              light
              size={rpx(20)}
              color="white"
              numberOfLines={0}
              style={titleStyle}
            >
              {title}
            </Typography.Label>
            <TaskNavBarSpinner
              animating={titleLoadingIndicator === true}
              offsetX={rpx(3)}
            />
          </View>
          <View
            css={`
              position: absolute;
              left: 0px;
              right: 0px;
              bottom: 0px;
              height: ${navBarHeight - safeAreaInsets.top}px;
              justify-content: space-between;
              align-items: center;
              flex-direction: row;
              padding-left: ${rpx(15)}px;
              padding-right: ${rpx(16)}px;
            `}
          >
            <TouchableOpacity
              css={`
                flex-direction: row;
                align-items: center;
                justify-content: flex-start;
              `}
              onPress={onBackPress}
            >
              <Icon
                name="arrow-back-circle-outline"
                size={rpx(32)}
                color="white"
              />
              {showVehicleInfo && (
                <Typography.Label
                  bold
                  size={rpx(24)}
                  lineHeight={rpx(32)}
                  color={'white'}
                  css={`
                    margin-left: ${rpx(10)}px;
                  `}
                >
                  {licensePlateNo}
                </Typography.Label>
              )}
              {showVehicleInfo && (
                <Typography.Label
                  light
                  size={rpx(18)}
                  lineHeight={rpx(32)}
                  color={Colors.White5}
                  css={`
                    margin-left: ${rpx(10)}px;
                  `}
                >
                  {vehicleName}
                </Typography.Label>
              )}
            </TouchableOpacity>
            {rightOptions != null ? (
              rightOptions()
            ) : onShowActions != null ? (
              <TaskHeaderMoreButton color="white" onPress={onShowActions} />
            ) : null}
            {accessoryText != null && (
              <View>
                <Typography.Label
                  light
                  size={rpx(11)}
                  color={Colors.White7_5}
                  css={`
                    text-align: center;
                  `}
                >
                  {accessoryText}
                </Typography.Label>
              </View>
            )}
          </View>
        </View>
      </>
    );
  },
);
